import { Avatar } from "@mui/material";
import { doc } from "firebase/firestore";
import React from "react";
import { db } from "firebaseApp";
import { useDocumentData } from "react-firebase-hooks/firestore";

export default function UserAvatar({uid}) {

  const docRef = uid ? doc(db, "userPublicProfiles", uid) : null;

  const [user, loading, error] = useDocumentData(docRef);

  if(error) {
    console.log(error)
  }

  if(loading) {
    return null;
  }
  
  return (
    <Avatar alt={user.username} src={user.avatarUrl} />
  );
}
